// React
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
// MUI
import { Grid, Card, Box, Button, Container, TextField, CardHeader, CardContent, Divider, FormControl } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
//Third party
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import SpinService from "../../../services/SpinService";
//components
import PermissionConstants from "../../../configs/PermissionConstants";
import { StyledDrawerForm } from "../../../configs/GoStyles";
import GoForm from "../../../components/Inputs/GoForm";
import usePermissions from "../../../hooks/usePermissions";

const InvoiceGenerationSchema = Yup.object().shape({
    schools: Yup.array().min(1).required()
});

const igformFields = [
    { name: "schools", title: "Schools", required: true, type: "multiselect", options: [], apiRequired: true, displayKey: "name", itemValue: "id" }];

const InvoiceGeneration = () => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [invoice_state, setInvoiceState] = useState({ schools: [] });
    const [formFields, setFormFields] = useState(igformFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const response = await post(EntityConstants.GENERATION_INVOICES_BY_SCHOOLS, values);
        if (response.ok) {
            toast.success(MessageContants.INVOICE_GENERATES);
        }
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies()
    }, [])

    return (
        <div>
            <Card>
                <Box >
                    <Container maxWidth={false}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Formik
                                enableReinitialize
                                initialValues={invoice_state}
                                validationSchema={InvoiceGenerationSchema}
                                onSubmit={(values) => handleSubmit(values)}
                            >
                                {({
                                    values,
                                    touched,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <StyledDrawerForm>
                                            <Grid
                                                container
                                                maxWidth="sm"
                                                rowSpacing={1}
                                                columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                                            >
                                                {formFields.map((formField, index) => {
                                                    return (
                                                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                                            <GoForm
                                                                config={formField}
                                                                values={values}
                                                                touched={touched}
                                                                errors={errors}
                                                                handleChange={handleChange}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            <br />
                                            <Box sx={{ p: 2, textAlign: "left" }}>
                                                {values.id === undefined && permissions.has(PermissionConstants.INVOICE_CREATE) &&
                                                    <Button
                                                        variant="contained"
                                                        startIcon={<Iconify icon="eva:save-fill" />}
                                                        type="submit"
                                                    >
                                                        Generate
                                                    </Button>
                                                }
                                            </Box>
                                        </StyledDrawerForm>
                                    </Form>
                                )}
                            </Formik>
                        </Grid>
                    </Container>
                </Box>
            </Card>
        </div>
    );
};

export default InvoiceGeneration;